import { store } from '../../store'
import call from './'
import callServer from '../call/callServer'
import eventBus from '@/event_bus'
import statusEvent from '@/util/call/klCnsAPI/statusEvent'
import helpers from '@/util/helpers'
import util from '@/util'

const getDefaultState = () => {
  return {
    isStatusSocketConnected: false,
    statusStompClient: null,
    isStatusConnecting: false
  }
}

const state = getDefaultState()
const getters = {
  IS_CALL_STATUS_CONNECTED: (state) => { return state.isStatusSocketConnected }
}
const mutations = {
  START_STATUS_CONNECT (state) {
    state.isStatusConnecting = true
  },
  END_STATUS_CONNECT (state) {
    state.isStatusConnecting = false
    state.isStatusSocketConnected = true
  },
  FAIL_STATUS_CONNECT (state) {
    state.isStatusConnecting = false
    state.isStatusSocketConnected = false
  },
  OPEN_STATUS (state) {
    statusEvent.connectUser(state)
  },
  CLOSE_STATUS () {
    if (!state.isStatusSocketConnected) return
    state.isStatusConnecting = false
    state.isStatusSocketConnected = false
    if (state.statusStompClient) {
      state.statusStompClient.close()
    }
  },
  sendMessageToStatusSocket (state, payload) {
    if (state.statusStompClient && state.statusStompClient.readyState === WebSocket.OPEN) {
      state.statusStompClient.send(payload)
    } else {
      // eventBus.$emit('websocket-disconnect')
    }
  }
}
const actions = {
  call_status_connect ({commit, state}) {
    const { enabledCallAgent, isExistCallAgent } = call.state

    if (!(enabledCallAgent && isExistCallAgent) || state.isStatusSocketConnected || (state.isStatusConnecting && !state.isStatusSocketConnected) || !callServer.state.callWebsocketUrl) {
      return false
    }
    commit('START_STATUS_CONNECT')

    // url 추가 필요
    const callStatusSocketUrl = callServer.state.callStatusUrl || helpers.findCallStatusUrl()
    if (!callStatusSocketUrl) return
    state.statusStompClient = new WebSocket(callStatusSocketUrl + '/whiteeye')
    state.statusStompClient.binaryType = 'arraybuffer'

    state.statusStompClient.onopen = function (e) {
      commit('END_STATUS_CONNECT')
      commit('OPEN_STATUS')

      // socket 오픈하면 처리할 이벤트 넣기
    }

    state.statusStompClient.onmessage = function (e) {
      let recvData = {}
      try {
        recvData = JSON.parse(e.data)
      } catch (e) {
        return
      }

      if (recvData.recvType) {
        const { recvType, data } = recvData

        switch (recvType) {
          case 'ping':
            const { currentBrandId, agentId } = store.getters
            const testMsg = JSON.stringify({'brandId': currentBrandId, 'agentId': agentId, 'sendType': 'pong'})
            commit('sendMessageToStatusSocket', testMsg)
            break
          case 'agt-status-list':
            commit('changeCallAgentList', data)
            break
          case 'ready-queue':
            eventBus.$emit('call-self-monitor', recvType, data)
            break
          case 'agt-status-tm':
            const statusTm = {}
            const { ready, acw, empty } = data
            if (ready) statusTm.waitTime = ready
            if (acw) statusTm.summaryTime = acw
            if (empty) statusTm.emptyTime = empty

            commit('SET_CONSULT_SATAUS', statusTm)
            break
          case 'agt-priv':
            const agentPriv = {
              totalTime: data.callTmSum,
              averageTime: data.callTmAvg,
              myCount: {
                inBound: data.inCallCount,
                outBound: data.outCallCount
              }
            }
            commit('SET_CONSULT_SATAUS', agentPriv)
            break
          case 'agt-tot':
            commit('SET_CONSULT_SATAUS', { maxCount: { inBound: data.inTotCnt, outBound: data.outTotCnt } })
            break
          case 'agt-avg':
            commit('SET_CONSULT_SATAUS', { averageCount: { inBound: data.avgInCalls, outBound: data.avgOutCalls } })
            break
        }
      }
    }

    state.statusStompClient.onclose = function (e) {
      commit('FAIL_STATUS_CONNECT')
      eventBus.$emit('status-reconnect-start')
    }
  },
  send_status ({commit, state}, params) {
    let { currentBrandId } = store.getters
    if (!currentBrandId && localStorage.getItem('token')) {
      currentBrandId = util.parseLoginToken().agentMappingBrandViews[0].brandId
    }
    const defaultObj = {'brandId': currentBrandId, 'sendType': 'status'}
    const statusMsg = JSON.stringify(Object.assign(defaultObj, params))
    commit('sendMessageToStatusSocket', statusMsg)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/callWebsocket/status.js